export enum HeroSize {
  Large = 'large',
  Small = 'small',
}

export enum HeroAreaStageBoxState {
  Show = 'show',
  Hide = 'hide',
}
